import { Pipe, PipeTransform } from '@angular/core';
import { ngdTranslate } from './translations';

@Pipe({
  name: 'ngdt'
})
export class NgdTranslatePipe implements PipeTransform {
  transform(value: any, args?: any): any {
    return ngdTranslate(value, args);
  }
}
